import {cloneElement, isValidElement} from 'react';
import {Controller} from 'react-hook-form';

const Input = ({type, name, control, children}) => {
  const createRenderField = (field) =>
    children && isValidElement(children) ? (
      cloneElement(children, {
        ...children.props,
        checked: field.value === children.props.value,
        onChange: (e) => field.onChange(e.target.value),
      })
    ) : (
      <input {...field} type={type} className="mt-1 block w-full px-3 py-2 border border-gray-300 bg-gray-100 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor" />
    );

  return (
    <Controller
      name={name}
      control={control}
      render={({field}) => createRenderField(field)}
    />
  );
};

export default Input;
